import React, { useEffect } from 'react'
import { useSelector } from 'store'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import M_FieldDateTimeSet from 'components/1_Atoms/2_Molecules/M_FieldDateTimeSetNew'
import M_FieldCodeBox from 'components/1_Atoms/2_Molecules/M_FieldCodeBox'
// import M_FieldTanto from 'components/1_Atoms/2_Molecules/M_FieldTanto'
import M_ButtonSubmit from 'components/1_Atoms/2_Molecules/M_ButtonSubmit'
import M_FieldLogKbn from 'components/1_Atoms/2_Molecules/M_FieldLogKbn'
import { organismGroupLog } from 'utils/logUtil'
import { useDateTime, useKbn, useJigyoshoCode, useJigyoshoName, useTokuisakiCode, useTokuisakiName, useTenpoCode, useTenpoName, useMail, useName, useAddMail, useSearch, useAddName } from 'hooks/useLog'
import { useEnterKeyFocusControl } from 'utils/focusControlUtil'
import { unDisplayNumber } from 'utils/numberUtil'
import { useMediaQueryContext } from 'MediaQueryProvider'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      // height: window.innerHeight * 0.3,
    },
    grid: {
      flexGrow: 1,
    },
    box: {
      textAlign: 'left',
    },
    impotant: {
      color: '#FF0000',
    },
  }),
)

const O_SearchBox = () => {
  useEffect(() => organismGroupLog('O_SearchBox'))
  const classes = useStyles()
  const register = useEnterKeyFocusControl()

  const [DT_FROM, DT_TO, changeDateTimeFrom, changeDateTimeTo] = useDateTime()
  const [torokuCheck, sakujoCheck, koshinCheck, changeToroku, changeSakujo, changeKoshin] = useKbn()
  const [JIGYO_CD, changeJigyoCode] = useJigyoshoCode()
  const [JIGYO_NM, submitJigyosho] = useJigyoshoName()
  const [TOKUI_CD, changeTokuisakiCode] = useTokuisakiCode()
  const [TOKUI_NM, submitTokuisaki] = useTokuisakiName()
  const [TEN_CD, changeTenpoCode] = useTenpoCode()
  const [TEN_NM, submitTenpo] = useTenpoName()
  const [MAIL, changeMail] = useMail()
  const [NAME, submitMail] = useName()
  const [ADD_MAIL, changeAddMail] = useAddMail()
  const [ADD_NAME, submitAddMail] = useAddName()
  const [clickSearch] = useSearch()
  const JIGYO_ERROR = useSelector((state) => state.SearchLogReducer.JIGYO_NM_ERROR)
  const TOKUI_ERROR = useSelector((state) => state.SearchLogReducer.TOKUI_NM_ERROR)
  const TEN_NM_ERROR = useSelector((state) => state.SearchLogReducer.TEN_NM_ERROR)
  const NAME_ERROR = useSelector((state) => state.SearchLogReducer.NAME_ERROR)
  const ADD_NAME_ERROR = useSelector((state) => state.SearchLogReducer.ADD_NAME_ERROR)
  const { isMobileSite } = useMediaQueryContext()

  useEffect(() => {
    // 初期設定の事業所で検索
    submitJigyosho()
  }, [])

  return (
    <div className={classes.root}>
      <Grid container>
        {/* //////////////////// 1 行目 //////////////////// */}
        <Grid item xs={isMobileSite ? 12 : 6} className={classes.grid}>
          {/* 年月日 */}
          <M_FieldDateTimeSet
            type="date" //
            label="年月日"
            key1={1}
            tab1={1}
            change1={changeDateTimeFrom}
            value1={DT_FROM}
            register1={register(1, 'number')}
            change2={changeDateTimeTo}
            value2={DT_TO}
            key2={2}
            tab2={2}
            register2={register(2, 'number')}
          />
        </Grid>
        <Grid item xs={isMobileSite ? 12 : 6} className={classes.grid}>
          {/* 事業所 */}
          <M_FieldCodeBox
            key={3} //
            tab={3}
            info={{
              label: '事業所',
              code: unDisplayNumber(JIGYO_CD),
              name: JIGYO_NM,
              change: changeJigyoCode,
              submit: submitJigyosho,
              error: JIGYO_ERROR,
              disabled: false,
            }}
            register={register(3, 'number', clickSearch, submitJigyosho)}
          />
        </Grid>

        {/* //////////////////// 2 行目 //////////////////// */}
        <Grid item xs={isMobileSite ? 12 : 6} className={classes.grid}>
          {/* 得意先 */}
          <M_FieldCodeBox
            key={4} //
            tab={4}
            info={{
              label: '得意先',
              code: unDisplayNumber(TOKUI_CD),
              name: TOKUI_NM,
              change: changeTokuisakiCode,
              submit: submitTokuisaki,
              error: TOKUI_ERROR,
              disabled: false,
            }}
            register={register(4, 'number', clickSearch, submitTokuisaki)}
          />
        </Grid>
        <Grid item xs={isMobileSite ? 12 : 6} className={classes.grid}>
          {/* 店舗 */}
          <M_FieldCodeBox
            key={5} //
            tab={5}
            info={{
              label: '店舗',
              code: unDisplayNumber(TEN_CD),
              name: TEN_NM,
              change: changeTenpoCode,
              submit: submitTenpo,
              error: TEN_NM_ERROR,
              disabled: false,
            }}
            register={register(5, 'number', clickSearch, submitTenpo)}
          />
        </Grid>

        {/* //////////////////// 3 行目 //////////////////// */}
        <Grid item xs={isMobileSite ? 12 : 6} className={classes.grid}>
          {/* メールアドレス */}
          <M_FieldCodeBox
            type={'text'}
            key={6} //
            tab={6}
            info={{
              label: 'メール',
              code: MAIL,
              name: NAME,
              change: changeMail,
              submit: submitMail,
              error: NAME_ERROR,
              disabled: false,
            }}
            register={register(6, 'text', clickSearch, submitMail)}
          />
        </Grid>
        <Grid item xs={isMobileSite ? 12 : 6} className={classes.grid}>
          {/* 登録者メール */}
          <M_FieldCodeBox
            key={7} //
            tab={7}
            type={'text'}
            info={{
              label: '登録者ﾒｰﾙ',
              code: ADD_MAIL,
              name: ADD_NAME,
              change: changeAddMail,
              submit: submitAddMail,
              error: ADD_NAME_ERROR,
              disabled: false,
            }}
            register={register(7, 'text', clickSearch, submitAddMail)}
          />
        </Grid>

        {/* //////////////////// 4 行目 //////////////////// */}
        <Grid item xs={isMobileSite ? 12 : 6} className={classes.grid}>
          {/* 登録区分 */}
          <M_FieldLogKbn
            label1="区分" //
            check1={torokuCheck}
            check2={sakujoCheck}
            check3={koshinCheck}
            event1={changeToroku}
            event2={changeSakujo}
            event3={changeKoshin}
            disabled={false}
          />
        </Grid>
        {isMobileSite ? <></> : <Grid item xs={12} sm={4} className={classes.grid}></Grid>}
        <Grid item xs={isMobileSite ? 12 : 2} className={classes.grid}>
          {/* 検索ボタン */}
          <Grid container justifyContent="flex-end">
            <M_ButtonSubmit label={'検索'} event={clickSearch} disabled={false} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
export default React.memo(O_SearchBox)
